module.exports = __webpack_public_path__ + "img/img14.db13166b.png";